export const NATURSKADE = {
  nickname: 'PRODUCTS.NATURSKADE.nickname',
  icon:'naturskade'
};
